
window.addEventListener("DOMContentLoaded", (event) => {
    console.log("Zyber JS loaded!");

    window.addEventListener('load', function() {
        console.log('All assets are loaded')
        let getRecent = document.getElementsByClassName("product-recently-viewed__content").length;
        setTimeout(() => {
            if(getRecent > 0) {
                console.log('recent products present');
                //recently viewed height 
                let getRecentHeight = document.querySelector(".product-recently-viewed__content").offsetHeight;
                let getProdItem = document.getElementsByClassName("product-recently-viewed-card");

                for (var i = 0; i < getProdItem.length; i++) {
                    console.log('getProdItem');
                    getProdItem[i].style.height = `${getRecentHeight}px`;
                }
            }
        }, "1000");

        //click on the check in store button to trigger popup
        function triggerStorePopup() {  
          setTimeout(() => {
            
            const modalButton = document.querySelector(".surface-pick-up-embed__modal-btn");
            if (modalButton) {
                modalButton.click();
                createStockTableEvents();
            } else {
              console.log('".surface-pick-up-embed__modal-btn not present')
            }

          }, "1000");
      }
        
      setTimeout(() => {
        triggerStorePopup()
      }, "1000");
    
    });


    // Set up load more stock locations button and disclosure ontoggle text changes
    function createStockTableEvents () {
      const storeList = document.querySelector('.check-instore__stores-list');
      if(storeList) {

        storeList.addEventListener('click', function(event) {
          if (event.target.matches('a.load-more')) {
              event.preventDefault(); 
              storeList.classList.toggle('show-all')
              document.querySelector('.load-more').textContent = storeList.classList.contains('show-all') ? 'Show fewer stores' : 'Load more stores';
          }
        });

        storeList.addEventListener('toggle', function(event) {
          if (event.target.matches('.disclosure')) {
              const toggleText = event.target.querySelector('.disclosure__toggle');
              if (event.target.open) {
                  toggleText.textContent = 'Collapse Branch details';
              } else {
                  toggleText.textContent = 'Branch details';
              }
          }
        });

        const loaderWrapper = document.getElementById('loader__wrapper');
        const loader = document.getElementById('loader');
        if (loaderWrapper) {
          loaderWrapper.classList.remove('loader__wrapper');
        } else {
            console.warn('Element with id "loader__wrapper" not found.');
        }
        
        if (loader) {
            loader.style.display = 'none';
        } else {
            console.warn('Element with id "loader" not found.');
        }
      }
    }

    const checkStoreBtn = document.querySelector(".check-instore");
    if (checkStoreBtn) {
        checkStoreBtn.addEventListener('click', triggerStorePopup, false);
    }  
});

// Get stock per location from Gadget endpoint
async function fetchStockByLocation(variantId) {

  let endpoint = `https://scott-electrical.gadget.app/api/inventory/${variantId}`;
  if (window.location.href.includes('staging')) {
    endpoint = `https://scott-electrical-staging.myshopify.com/a/gadget-staging/api/inventory/${variantId}`;
  } 

  try {
    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data.data; 

  } catch (error) {
    console.error('Error fetching stock data:', error);
    return []; 
  }
}


